import Row from '@components/Row';
import styled from '@emotion/styled';

import LeftIcon from './LeftIcon';
import RightIcon from './RightIcon';

interface Props {
    slickPrev?: ()=>void;
    slickNext?: ()=>void;
    size?: number;
    current: number;
}

function ImageIndicator({
    slickPrev, slickNext, size, current,
}:Props) {
    return (
        <Container justify='center' align='center'
            fullWidth
            spacing={2}>
            <LeftIcon cursor='pointer'
                onClick={slickPrev}/>
            <Row spacing={3}>
                {Array.from({ length: size || 0 }).map((_, i) => (
                    <Dot active={i === current}
                        key={`indicator ${i}`}/>
                ))}
            </Row>
            <RightIcon cursor='pointer'
                onClick={slickNext}/>
        </Container>
    );
}

const Container = styled(Row)`
    margin-top: 16px;
`;

const Dot = styled.div<{active: boolean}>`
    background-color: ${(props) => `var(--color-gray${props.active ? 6 : 5})`};
    border-radius: 4px;
    height: 8px;
    width: 8px;`;

export default ImageIndicator;
